import type { Action } from "svelte/action"
import { getEventCallbacks } from "./eventBus"
import { rerender } from "./store"

export const spaLink: Action<HTMLAnchorElement> = (node) => {
    const onClick = (event: MouseEvent) => {
        // prevent execution if anchor has attribute data-spa-prevent="true"
        if (node.dataset.spaPrevent && node.dataset.spaPrevent !== "false") {
            return
        }
        const anchor = event.currentTarget as HTMLAnchorElement
        if ((anchor.target === "" || anchor.target === "_self") && anchor.href.startsWith(window.location.origin)) {
            event.preventDefault()
            // check is it is current url
            const currentUrl = window.location.pathname + window.location.search + window.location.hash
            const newUrl = anchor.pathname + anchor.search + anchor.hash
            if (currentUrl === newUrl) {
                return
            }
            spaNavigate(anchor.pathname + anchor.search + anchor.hash)
        }
    }

    node.addEventListener("click", onClick)

    return {
        destroy() {
            node.removeEventListener("click", onClick)
        },
    }
}

export const spaNavigate = (to: string, options?: { replace?: boolean }) => {
    if (getEventCallbacks("navigate")) {
        let callbacks = Object.values(getEventCallbacks("navigate"))
        for (let i = 0; i < callbacks?.length; i++) {
            if (callbacks[i](to, options) === false) return
        }
    }
    console.log("rerender")
    rerender.set(Math.random())
    if (options?.replace) {
        window.history.replaceState(null, "", to)
    } else {
        window.history.pushState(null, "", to)
    }
}

export const spaBack = () => {
    window.history.back()
}

// TODO: spaLinks container for containing {@html ...}
